import React, { Component } from "react";
import {
  MetaRegional,
  ProcesoResultado
} from "../../../../types/MembresiaMetaCarga";

interface Props {
  metasRegionales: MetaRegional[];
  esMetasActuales?: boolean;
  nombreArchivo?: string;
  fechaCarga?: string;
  resultado?: ProcesoResultado;
  mensaje?: string;
}

export default class ConfiguracionMetasTable extends Component<Props> {
  getRowStyle = (resultado: ProcesoResultado) => {
    switch (resultado) {
      case ProcesoResultado.ERROR:
        return { backgroundColor: "#f8d7da" };
      case ProcesoResultado.WARNING:
        return { backgroundColor: "#fffbdbff" };
      default:
        return {};
    }
  };

  render() {
    const {
      metasRegionales,
      esMetasActuales,
      nombreArchivo,
      fechaCarga,
      resultado,
      mensaje
    } = this.props;

    return (
      <>
        {resultado === ProcesoResultado.ERROR && mensaje && (
          <div className="alert alert-danger mb-3" role="alert">
            <strong>Error</strong>
            <div>
              <small>{mensaje}</small>
            </div>
          </div>
        )}
        {esMetasActuales && (nombreArchivo || fechaCarga) && (
          <div className="alert alert-info mb-3" role="alert">
            <strong>Metas Actuales</strong>
            {nombreArchivo && (
              <div>
                <small>Archivo: {nombreArchivo}</small>
              </div>
            )}
            {fechaCarga && (
              <div>
                <small>
                  Fecha de carga:{" "}
                  {new Date(fechaCarga).toLocaleDateString("es-MX", {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                  })}
                </small>
              </div>
            )}
          </div>
        )}
        {metasRegionales.map((regional, idx) => (
          <div key={idx} className="mb-4">
            <div className="row">
              <div className="col-12 p-0" style={{ lineHeight: "40px" }}>
                Región {regional.numeroRegion} &nbsp; (Tiene{" "}
                {(regional.clubes && regional.clubes.length) || 0} clubes)
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-striped table-bordered table-sm">
                    <thead className="thead-dark">
                      <tr>
                        <th>Club</th>
                        <th>Meta Ventas</th>
                        <th>Meta Reactivaciones</th>
                        <th>Meta Consolidada</th>
                        <th>Mensaje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={this.getRowStyle(regional.resultado)}>
                        <td>
                          <strong>TOTAL REGIÓN {regional.numeroRegion}</strong>
                        </td>
                        <td>
                          <strong>{regional.metaVentas}</strong>
                        </td>
                        <td>
                          <strong>{regional.metaReactivaciones}</strong>
                        </td>
                        <td>
                          <strong>{regional.metaConsolidada}</strong>
                        </td>
                        <td>{regional.mensaje || "-"}</td>
                      </tr>

                      {regional.clubes && regional.clubes.length > 0 && (
                        <>
                          {regional.clubes.map((club, i) => (
                            <tr
                              key={i}
                              style={this.getRowStyle(club.resultado)}
                            >
                              <td>{club.club}</td>
                              <td>{club.metaVentas}</td>
                              <td>{club.metaReactivaciones}</td>
                              <td>{club.metaConsolidada}</td>
                              <td>{club.mensaje || "-"}</td>
                            </tr>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }
}
